module.exports = __webpack_public_path__ + "static/img/5areaB_7.cda6d9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_7.png
// module id = 1208
// module chunks = 1